import React from 'react';
import propTypes from 'prop-types';
export const AgeIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      fill={color}
      height={sizeInPixel}
      width={sizeInPixel}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 21.69 21.69"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <path
            d="M21.267,12.833c0-4.332-5.576-6.527-8.831-3.576c-1.06-2.343-3.973-2.929-5.972-0.986
           C5.186,6.107,1.768,6.203,0.679,8.507C0.51,8.867,0.424,9.254,0.424,9.673c0,0.04,0,5.301,0,5.301H5.47v2.244h5.373v4.472h10.423
           C21.267,21.69,21.267,12.969,21.267,12.833z"
          />
          <circle cx="16.124" cy="3.558" r="3.558" />
          <circle cx="9.007" cy="3.843" r="2.649" />
          <circle cx="3.565" cy="4.208" r="1.958" />
        </g>
      </g>
    </svg>
  );
};
AgeIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
AgeIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
